<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} Contacto
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
            <v-row>
              <!-- Nombre -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                  <v-text-field
                    filled
                    rounded
                    label="Nombre"
                    class="rounded-lg"
                    v-model="payload.name"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Apellido -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="Nombre" rules="" v-slot="{ errors }">
                  <v-text-field
                    filled
                    rounded
                    label="Apellido"
                    class="rounded-lg"
                    v-model="payload.lastNAme"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Documento -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="Documento de identidad" rules="" v-slot="{ errors }">
                  <v-text-field
                    filled
                    rounded
                    class="rounded-lg"
                    label="Documento de identidad"
                    v-model="payload.document"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Telefono 1 -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="Telefono 1" rules="required" v-slot="{ errors }">
                  <v-text-field
                    filled
                    rounded
                    type="tel"
                    label="Telefono 1"
                    prepend-inner-icon="mdi-phone"
                    class="phone-field rounded-lg"
                    v-model="payload.phone1"
                    :error-messages="errors"
                  >
                    <v-icon
                      @click="useAsWhatsapp(1)"
                      slot="append"
                      :color="useWhatsApp === 1 ? 'success' : 'grey lighten-1'"
                      style="cursor:pointer"
                    >
                      mdi-whatsapp
                    </v-icon>
                  </v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Telefono 2 -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="Telefono 2" v-slot="{ errors }">
                  <v-text-field
                    filled
                    rounded
                    type="tel"
                    label="Telefono 2"
                    prepend-inner-icon="mdi-phone"
                    class="phone-field rounded-lg"
                    v-model="payload.phone2"
                    :error-messages="errors"
                  >
                    <v-icon
                      @click="useAsWhatsapp(2)"
                      slot="append"
                      :color="useWhatsApp === 2 ? 'success' : 'grey lighten-1'"
                      style="cursor:pointer"
                    >
                      mdi-whatsapp
                    </v-icon>
                  </v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- WhatsApp -->
              <v-slide-y-transition>
                <v-col cols="12" sm="6" class="pb-0" v-show="true || !useWhatsApp">
                  <ValidationProvider name="Whatsapp" v-slot="{ errors }">
                    <v-text-field
                      filled
                      rounded
                      type="tel"
                      label="Whatsapp"
                      class="phone-field rounded-lg"
                      prepend-inner-icon="mdi-whatsapp"
                      v-model="payload.whatsapp"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-slide-y-transition>

              <!-- Email -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="Correo" rules="email" v-slot="{ errors }">
                  <v-text-field
                    filled
                    rounded
                    label="Correo"
                    class="rounded-lg"
                    prepend-inner-icon="mdi-email"
                    v-model="payload.email"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Empresa -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="Empresa" v-slot="{ errors }">
                  <v-text-field
                    filled
                    rounded
                    label="Empresa"
                    class="rounded-lg"
                    prepend-inner-icon="mdi-briefcase"
                    v-model="payload.business"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Tipo -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="Tipo" v-slot="{ errors }">
                  <v-text-field
                    filled
                    rounded
                    label="Tipo"
                    class="rounded-lg"
                    v-model="payload.type"
                    prepend-inner-icon="mdi-bookshelf"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Foto de perfil -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="Imagen de perfil" v-slot="{ errors }">
                  <!-- <v-text-field
                    v-model="payload.type"
                    :error-messages="errors"
                    label="Tipo"
                  ></v-text-field> -->
                  <v-file-input
                    filled
                    rounded
                    class="rounded-lg"
                    label="Imagen de perfil"
                    prepend-icon=""
                    prepend-inner-icon="mdi-camera"
                    accept="image/png, image/jpeg"
                    v-model="selectedFile"
                    :error-messages="errors"
                    @change="handleFileInputChange"
                  ></v-file-input>
                </ValidationProvider>
              </v-col>

              <!-- Comentarios -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="Comentarios" v-slot="{ errors }">
                  <v-textarea
                    filled
                    rounded
                    :rows="3"
                    label="Comentarios"
                    class="rounded-lg"
                    prepend-inner-icon="mdi-comment"
                    v-model="payload.comments"
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Agentes -->
              <v-col cols="12">
                <v-select
                  v-model="payload.attend_user"
                  prepend-inner-icon="mdi-account"
                  required
                  filled
                  rounded
                  dense
                  class="rounded-small"
                  item-text="name"
                  item-value="id"
                  :items="agentList"
                  label="Agente asignado"
                ></v-select>
              </v-col>

              <!-- Es grupo -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="es grupo" rules="required" v-slot="{ errors }">
                  <v-radio-group v-model="payload.isGroup" :error-messages="errors" row>
                    <template v-slot:label>
                      ¿Es Grupo?
                    </template>
                    <v-radio label="Sí" :value="1"></v-radio>
                    <v-radio label="No" :value="0"></v-radio>
                  </v-radio-group>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8 shadow-4"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import { DIALOG_MAX_HEIGHT } from "@/utils";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
  },
  components: { vuescroll },

  data() {
    return {
      DIALOG_MAX_HEIGHT,
      isLoading: false,
      selectedFile: null,
      agentList: [],
      payload: {
        name: "",
        lastNAme: "",
        phone1: "",
        phone2: "",
        whatsapp: "",
        email: "",
        business: "",
        type: null,
        comments: "",
        document: null,
        attend_user: null,
        isGroup: null,
        Contactscol: "",
      },
      useWhatsApp: null,
    };
  },

  computed: {
    phone1() {
      return this.payload.phone1;
    },
    phone2() {
      return this.payload.phone2;
    },
  },
  created() {
    this.getAgents();
    this.payload = { ...this.dataToEdit };
  },

  watch: {
    useWhatsApp(val) {
      if (!val) this.payload.whatsapp = "";
      if (val === 1) this.payload.whatsapp = this.payload.phone1;
      if (val === 2) this.payload.whatsapp = this.payload.phone2;
    },
    phone1(val) {
      if (this.useWhatsApp === 1) this.payload.whatsapp = val;
    },
    phone2(val) {
      if (this.useWhatsApp === 2) this.payload.whatsapp = val;
    },
  },

  methods: {
    handleFileInputChange() {
      const file = this.selectedFile;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.payload.profilePicUrl = reader.result;
        // console.log(reader.result);
        this.payload.profilePicUrl = reader.result;
      };
    },

    async getAgents() {
      try {
        const { data } = await PbxHttpClient.get("/clients/show/agents_select");
        this.agentList = data.data;
        this.agentList.unshift({
          id: null,
          name: "Ninguno",
        });
      } catch (err) {
        console.log(err);
      }
    },

    async submitForm() {
      this.isLoading = true;

      try {
        // Imagen
        // if (this.selectedFile != null) {
        //   let InstFormData = new FormData();
        //   InstFormData.append("archivo", this.selectedFile);
        //   this.payload.profilePicUrl = InstFormData;
        // }

        // eslint-disable-next-line no-unused-vars
        const { id, ...payload } = this.payload;

        // console.log(payload);

        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/admin/contacts/${this.payload.id}`, payload)
          : await PbxHttpClient.post("/admin/contacts", this.payload);
        this.closeDialog(data);

        this.$snotify.success("Contacto creado con exito", "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo guardar los cambios", "¡Error!");
      }

      this.isLoading = false;
    },
    useAsWhatsapp(number) {
      if (this.useWhatsApp === number) this.useWhatsApp = null;
      else this.useWhatsApp = number;
    },
    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },
  },
};
</script>

<style></style>
